import {
  radio_styles_default
} from "./chunk.6WNXGNKF.js";
import {
  labelXSmall
} from "./chunk.GAOIIZQS.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/radio/radio.styles.ts
var radio_styles_default2 = r` ${radio_styles_default} ${component_mobile_styles_default} .radio__control { border: 1px solid var(--sl-color-gray-400); } .radio--checked .radio__control { border: 1px solid var(--sl-color-primary-600); background-color: var(--sl-color-neutral-0); } .radio--checked .radio__icon { background-color: var(--sl-color-primary-600); border-radius: var(--sl-border-radius-circle); color: var(--sl-color-primary-600); height: 10px; width: 10px; margin: auto; } .radio--disabled { color: var(--sl-color-gray-700); opacity: unset; } .radio--disabled .radio__control { background-color: var(--sl-color-gray-200); } .radio:not(.radio--checked):not(.radio--disabled) .radio__control:hover, .radio:not(.radio--checked):not(.radio--disabled):hover .radio__control { border-color: var(--sl-color-primary-600); } .radio.radio--checked:not(.radio--disabled) .radio__control:hover, .radio.radio--checked:not(.radio--disabled):hover .radio__control { border-color: var(--sl-color-primary-500); background-color: var(--sl-color-neutral-0); } .radio.radio--checked:not(.radio--disabled) .radio__control:hover .radio__icon, .radio.radio--checked:not(.radio--disabled):hover .radio__control .radio__icon { background-color: var(--sl-color-primary-500); color: var(--sl-color-primary-500); } .radio { ${labelXSmall} } `;

export {
  radio_styles_default2 as radio_styles_default
};
